import content from "../../../config/content.json";
import useScreenSize from "../../../hooks/useScreenSize";
import { Container } from "../../common/Container/Container";
import Hero, { HeroContent } from "../../common/Hero/Hero";
import { HighlightedTableContent } from "../../common/HighlightedTable/HighlightedTable";
import MainCallToAction, {
	MainCallToActionContent,
} from "../../common/MainCallToAction/MainCallToAction";
import bgImageDesktop from "../../imagenes/home/fixed_phone_large.webp";
import bgImageMobile from "../../imagenes/home/home-hero--mobile-uncompressed.webp";
import "./Home.scss";
import Calculator, {
	CalculatorContent,
} from "./sections/Calculator/Calculator";
import Carousel, { CarouselContent } from "./sections/Carousel/Carousel";
import Comparison, { ColumnHeader } from "./sections/Comparison/Comparison";
import CoreValues, {
	CoreValuesContent,
} from "./sections/CoreValues/CoreValues";
import Problem, { ProblemContent } from "./sections/Problem/Problem";
import Solution, { SolutionContent } from "./sections/Solution/Solution";

const Home = () => {
	const { width } = useScreenSize();
	const isMobile = width < 768;
	const homeContent = content.pages.home;

	const hero = homeContent.hero as HeroContent;
	const problem = homeContent.problem as ProblemContent;
	const solution = homeContent.solution as SolutionContent;
	const coreValues = homeContent.coreValues as CoreValuesContent;
	const comparison =
		homeContent.comparison as HighlightedTableContent<ColumnHeader>;
	const calculator = homeContent.calculator as CalculatorContent;
	const carousel = homeContent.carousel as CarouselContent;
	const mainCallToAction =
		homeContent.mainCallToAction as MainCallToActionContent;

	return (
		<Container className="home" headerWithTransparentBackground>
			<Hero
				sectionContent={hero}
				isMobile={isMobile}
				bgImageMobile={bgImageMobile}
				bgImageDesktop={bgImageDesktop}
			/>
			<Problem sectionContent={problem} />
			<Solution sectionContent={solution} />
			<div className="gradient">
				<Carousel sectionContent={carousel} isMobile={isMobile} />
				<CoreValues sectionContent={coreValues} />
				<Comparison sectionContent={comparison} isMobile={isMobile} />
				<Calculator sectionContent={calculator} />
			</div>
			<MainCallToAction sectionContent={mainCallToAction} isMobile={isMobile} />
		</Container>
	);
};

export default Home;
